module.exports = __webpack_public_path__ + "static/media/34_B.18a06e15.png";